const mobileMenu = document.querySelector('.rf-mobile-menu');

if (mobileMenu) {
  const closeMenu = () => mobileMenu.removeAttribute('open');

  document.addEventListener('click', (event) => {
    if (mobileMenu.open && event.target instanceof Node && !mobileMenu.contains(event.target)) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu.open) {
      closeMenu();
      mobileMenu.querySelector('summary')?.focus();
    }
  });

  mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

  const desktop = window.matchMedia('(min-width: 1101px)');
  const handleViewportChange = (event) => {
    if (event.matches) closeMenu();
  };

  desktop.addEventListener?.('change', handleViewportChange);
}
